import React, { FunctionComponent } from 'react';
import { Flex, Text } from 'rebass/styled-components';
import { ReactComponent as IconBan } from '../../../assets/icon-ban.svg';
import { ReactComponent as IconSuccess } from '../../../assets/green-check.svg';
import { ReactComponent as IconFailure } from '../../../assets/icon-error.svg';
import { ReactComponent as IconInvalid } from '../../../assets/icon-warn-hollow.svg';
import { ReactComponent as IconDisabled } from '../../../assets/icon-disabled.svg';
import {
  PolicyResultProps,
  policyEvalResultToTestIdMapper,
  policyActionResultTitleMapper,
} from '..';
import { PolicyEvalDisposition } from '../../../enums';

interface PolicyResultIconProps {
  policyEvalDisposition: PolicyEvalDisposition;
}

const PolicyResultIcon: FunctionComponent<
PolicyResultIconProps
> = ({ policyEvalDisposition }: PolicyResultIconProps): React.ReactElement => {
  switch (policyEvalDisposition) {
    case PolicyEvalDisposition.MATCH:
      return <Text variant="success"><IconSuccess data-testid={policyEvalResultToTestIdMapper(policyEvalDisposition)} /></Text>;
    case PolicyEvalDisposition.NO_MATCH:
      return <Text variant="primary"><IconBan data-testid={policyEvalResultToTestIdMapper(policyEvalDisposition)} /></Text>;
    case PolicyEvalDisposition.DISABLED:
      return <Text variant="primary"><IconDisabled data-testid={policyEvalResultToTestIdMapper(policyEvalDisposition)} /></Text>;
    case PolicyEvalDisposition.EXCEPTION:
      return <Text variant="error"><IconFailure data-testid={policyEvalResultToTestIdMapper(policyEvalDisposition)} /></Text>;
    case PolicyEvalDisposition.INVALID:
      return <Text variant="warn"><IconInvalid data-testid={policyEvalResultToTestIdMapper(policyEvalDisposition)} /></Text>;
    default:
      return <Text />;
  }
};

const PolicyResultComponent: FunctionComponent<
PolicyResultProps
> = ({ policyEvalDisposition, order, isEmphasizedPolicyResult }: PolicyResultProps) => (
  <Flex>
    <Text variant="primary" color="greyMiddle" width={42}>{order}</Text>
    <PolicyResultIcon policyEvalDisposition={policyEvalDisposition} />
    <Text
      variant={isEmphasizedPolicyResult ? 'primaryBold' : 'primary'}
      ml={2}
      sx={{
        textOverflow: 'ellipsis',
        overflow: 'hidden',
      }}
      display={['none', 'none', 'none', 'none', 'block']}
    >
      {policyActionResultTitleMapper(policyEvalDisposition)}
    </Text>
  </Flex>
);

export default PolicyResultComponent;
